import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "app-card-dmd",
	templateUrl: "./card-dmd.component.html",
})
export class CardDmdComponent implements OnInit {
	@Input() dmdId: string;
	@Input() dmdNumero: string;
	@Input() priority: string = "Moyenne";
	@Input() userImage: string = "./assets/images/users/avatar.png";
	@Input() userName: string;
	@Input() dmdTitle: string;
	@Input() dmdDetailsLink: string = "/tasks/details";
	@Input() dmdDate: string;
	@Input() commentsCount: number = 0;
	@Input() articlesCount: number = 0;
	@Input() demandeur: any;
	@Output() click = new EventEmitter();
	constructor() {}

	ngOnInit() {}
}
